'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CssStyles;

var _constants = require('../constants');

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _WixStylesFontUtils = require('@wix/wixrest-utils/dist/WixStylesFontUtils');

var _WixStylesFontUtils2 = _interopRequireDefault(_WixStylesFontUtils);

var _WixStylesColorUtils = require('@wix/wixrest-utils/dist/WixStylesColorUtils');

var _WixStylesColorUtils2 = _interopRequireDefault(_WixStylesColorUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLES = {
    TEXT_COLOR: 'color-5',
    BACKGROUND_COLOR: 'color-1',
    FONT: 'Body-M',
    OPTION_HOVER_COLOR: 'color-5'
};

var OPACITY = {
    TEXT: 0.7,
    DISABLED_TEXT: 0.3,
    NATIVE_OPTION_BG: 0.8,
    OPTION_HOVER: 0.1,
    DATE_PICKER_NAVIGATION_HOVER: 0.8,
    DATE_PICKER_NAVIGATION_DISABLED: 0.2,
    DATE_PICKER_DAY_DISABLED: 0.3,
    FIELD_HOVER: 0.95
};

function getFontValue(font) {
    var value = font;

    if (font.value) {
        value = font.value;
    } else if (font.family) {
        if (_lodash2.default.isString(font.family)) {
            font.family = font.family.split(',');
        }
        value = _WixStylesFontUtils2.default.toFontCssValue(font);
    }

    return value;
}

function getColorValue(color) {
    var value = color;

    if (color.value) {
        value = color.value;
    } else if (color.rgba) {
        value = color.rgba;
    } else if (color.rgb) {
        value = color.rgb;
    }

    return value;
}

function generateFontDefaults() {
    var _ref2;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fieldFont: 'FONT' },
        fieldFont = _ref.fieldFont;

    return _ref2 = {}, _ref2[fieldFont] = STYLES.FONT, _ref2;
}

function generateColorDefaults() {
    var _ref4;

    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fieldFill: 'BACKGROUND_COLOR',
        fieldColor: 'TEXT_COLOR', fieldBorderWidth: 'TEXT_COLOR' },
        fieldFill = _ref3.fieldFill,
        fieldColor = _ref3.fieldColor,
        fieldBorderWidth = _ref3.fieldBorderWidth;

    var siteColors = arguments[1];

    return _ref4 = {}, _ref4[fieldFill] = getColorValue(siteColors[STYLES.BACKGROUND_COLOR]), _ref4[fieldColor] = getColorValue(siteColors[STYLES.TEXT_COLOR]), _ref4[fieldBorderWidth] = getColorValue(siteColors[STYLES.TEXT_COLOR]), _ref4;
}

function CssStyles(frame, type, styles) {
    var wixParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var isHebrew = arguments[4];
    var params = styles.params,
        siteColors = styles.colors,
        siteTextPresets = styles.fonts;

    var defaultFonts = !_lodash2.default.isEmpty(wixParams) ? generateFontDefaults(wixParams) : {};
    var defaultColors = _lodash2.default.isEmpty(wixParams) ? generateColorDefaults(wixParams, siteColors) : {};

    var overridingFonts = _WixStylesFontUtils2.default.getFullFontStyles({ fonts: params.fonts, siteTextPresets: siteTextPresets, defaults: defaultFonts, isHebrew: isHebrew });
    var overridingColors = _lodash2.default.isEmpty(params.colors) ? {} : _WixStylesColorUtils2.default.getFullColorStyles({ colorStyles: params.colors, siteColors: siteColors, defaults: defaultColors });

    var siteColorsMapped = _lodash2.default.reduce(siteColors, function (result, color) {
        result[color.reference] = color;
        return result;
    }, {});
    var fieldFont = getFont(wixParams.fieldFont, params.fonts, styles.fonts, overridingFonts, STYLES.FONT);
    var fieldFill = getColor(wixParams.fieldFill, params.colors, siteColorsMapped, overridingColors, STYLES.BACKGROUND_COLOR);
    var fieldColor = getColor(wixParams.fieldColor, params.colors, siteColorsMapped, overridingColors, STYLES.TEXT_COLOR);
    var fieldBorderWidth = getNumber(wixParams.fieldBorderWidth, params, 1);

    return {
        toString: function toString() {
            var result = '';

            switch (frame) {
                case _constants.FRAME_TYPES.FIELD_FRAME:
                    result = fieldFrame();
                    break;
                case _constants.FRAME_TYPES.PANEL_FRAME:
                    result = panelFrame(type);
                    break;
            }

            return result;
        }
    };

    function fieldFrame() {
        return '\n                .' + _constants.CLASSES.FIELD + ' {\n                    background-color: ' + fieldFill + ';\n                    ' + ((fieldFont.indexOf('font:') === -1 ? 'font:' : '') + fieldFont) + '\n                }\n                .' + _constants.CLASSES.FIELD + ' .' + _constants.CLASSES.FIELD_INNER + ' {\n                    background-color: ' + fieldFill + ';\n                    color: ' + fieldColor + ';\n                    outline: none;\n                }\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':hover ,\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':focus ,\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':active {\n                    background-color: ' + (0, _color2.default)(fieldFill).mix((0, _color2.default)(fieldColor), OPACITY.FIELD_HOVER).rgbaString() + ';                    \n                }\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ' {\n                    border: ' + fieldBorderWidth + 'px solid ' + fieldColor + ';          \n                }\n                .' + _constants.CLASSES.FIELD + '.' + _constants.CLASSES.FIELD_DISABLED + ' .' + _constants.CLASSES.FIELD_INNER + ' {\n                    border: ' + fieldBorderWidth + 'px solid ' + (0, _color2.default)(fieldColor).alpha(OPACITY.DISABLED_TEXT).rgbString() + ';          \n                }\n                .' + _constants.CLASSES.FIELD + ' .' + _constants.CLASSES.FIELD_INNER + ' .' + _constants.CLASSES.FIELD_LABEL + ' {\n                    color: ' + fieldColor + ';\n                    height: ' + (_constants.FIELD_HEIGHT - 2 * fieldBorderWidth) + 'px;\n                    line-height: ' + (_constants.FIELD_HEIGHT - 2 * fieldBorderWidth) + 'px !important;\n                }\n                .' + _constants.CLASSES.FIELD + '.' + _constants.CLASSES.FIELD_DISABLED + ' .' + _constants.CLASSES.FIELD_INNER + ' .' + _constants.CLASSES.FIELD_LABEL + ' {\n                    color: ' + (0, _color2.default)(fieldColor).alpha(OPACITY.DISABLED_TEXT).rgbString() + ';\n                }\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':hover,\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':focus,\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':active,\n                .' + _constants.CLASSES.FIELD + '.' + _constants.CLASSES.FIELD_OPEN + ' .' + _constants.CLASSES.FIELD_INNER + ' {\n                    border: ' + fieldBorderWidth + 'px solid ' + fieldColor + ';          \n                }\n                .' + _constants.CLASSES.FIELD + '.' + _constants.CLASSES.FIELD_OPEN + ' .' + _constants.CLASSES.FIELD_INNER + ' .' + _constants.CLASSES.FIELD_LABEL + ',\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':hover .' + _constants.CLASSES.FIELD_LABEL + ',\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':focus .' + _constants.CLASSES.FIELD_LABEL + ',\n                .' + _constants.CLASSES.FIELD + ':not(.' + _constants.CLASSES.FIELD_DISABLED + ') .' + _constants.CLASSES.FIELD_INNER + ':active .' + _constants.CLASSES.FIELD_LABEL + ' {\n                    color: ' + fieldColor + ';\n                }\n                .' + _constants.CLASSES.FIELD + ' .' + _constants.CLASSES.FIELD_INNER + ' .' + _constants.CLASSES.FIELD_CHEVRON + ' svg path {\n                    fill: ' + fieldColor + ';\n                }\n                .' + _constants.CLASSES.FIELD + '.' + _constants.CLASSES.FIELD_DISABLED + ' .' + _constants.CLASSES.FIELD_INNER + ' .' + _constants.CLASSES.FIELD_CHEVRON + ' svg path {\n                    fill: ' + (0, _color2.default)(fieldColor).alpha(OPACITY.DISABLED_TEXT).rgbString() + ';\n                }\n                \n                .' + _constants.CLASSES.FIELD + ' .' + _constants.CLASSES.FIELD_INNER + ' select option {\n                    background-color: ' + (0, _color2.default)(fieldFill).alpha(OPACITY.NATIVE_OPTION_BG).rgbString() + ';\n                }\n                \n                .' + _constants.CLASSES.FIELD + ' .' + _constants.CLASSES.FIELD_INNER + ' select option:hover {\n                    background-color: ' + (0, _color2.default)(siteColors[STYLES.OPTION_HOVER_COLOR]).alpha(OPACITY.OPTION_HOVER).rgbString() + ';\n                }\n            ';
    }

    function panelFrame(type) {
        var result = panelStyles();

        switch (type) {
            case _constants.COMPONENT_TYPES.SELECT_TYPE:
                result += selectStyles();
                break;
            case _constants.COMPONENT_TYPES.DATE_PICKER_TYPE:
                result += datePickerStyles();
                break;
        }

        return result;
    }

    function panelStyles() {
        return '\n                .' + _constants.CLASSES.PANEL_WRAPPER + ' {\n                    background-color: ' + fieldFill + ';\n                    color: ' + fieldColor + ';\n                    border: 1px solid ' + fieldColor + ';\n                    ' + ((fieldFont.indexOf('font:') === -1 ? 'font:' : '') + fieldFont) + '\n                }\n                .' + _constants.CLASSES.PANEL_WRAPPER + ' * {\n                    ' + ((fieldFont.indexOf('font:') === -1 ? 'font:' : '') + fieldFont) + '\n                }\n            ';
    }

    function selectStyles() {
        return '\n                .' + _constants.CLASSES.SELECT_OPTION + '.' + _constants.CLASSES.SELECT_OPTION_MARKED + ' {\n                    background-color: ' + (0, _color2.default)(siteColors[STYLES.OPTION_HOVER_COLOR]).alpha(OPACITY.OPTION_HOVER).rgbString() + ';\n                }\n            ';
    }

    function datePickerStyles() {
        return '\n                .' + _constants.CLASSES.DATE_PICKER_CLOSE + ' svg path {                \n                    stroke: ' + fieldColor + ';\n                }\n                .' + _constants.CLASSES.DATE_PICKER_CLOSE + ':hover svg path {\n                    stroke: ' + (0, _color2.default)(fieldColor).alpha(OPACITY.DATE_PICKER_NAVIGATION_HOVER).rgbString() + ';                \n                }\n                \n                .' + _constants.CLASSES.DATE_PICKER_CHEVRON + ' svg path {\n                    fill: ' + fieldColor + ';\n                }\n                .' + _constants.CLASSES.DATE_PICKER_CHEVRON + ':hover svg path {\n                    fill: ' + (0, _color2.default)(fieldColor).alpha(OPACITY.DATE_PICKER_NAVIGATION_HOVER).rgbString() + ';\n                }\n                .' + _constants.CLASSES.DATE_PICKER_CHEVRON + '.' + _constants.CLASSES.DATE_PICKER_CHEVRON_DISABLED + ' svg path {\n                    fill: ' + (0, _color2.default)(fieldColor).alpha(OPACITY.DATE_PICKER_NAVIGATION_DISABLED).rgbString() + ';\n                }\n                \n               \n                .' + _constants.CLASSES.DATE_PICKER_DAY + '.' + _constants.CLASSES.DATE_PICKER_DAY_SELECTED + ' {\n                    color: ' + fieldFill + ';\n                }\n                .' + _constants.CLASSES.DATE_PICKER_DAY + ',\n                 .' + _constants.CLASSES.DATE_PICKER_DAY + ':not(.' + _constants.CLASSES.DATE_PICKER_DAY_SELECTED + ').' + _constants.CLASSES.DATE_PICKER_DAY_HOVERED + ' {\n                    color: ' + fieldColor + ';\n                }\n                .' + _constants.CLASSES.DATE_PICKER_DAY + '.' + _constants.CLASSES.DATE_PICKER_DAY_DISABLED + ' {\n                    color: ' + (0, _color2.default)(fieldColor).alpha(OPACITY.DATE_PICKER_DAY_DISABLED).rgbString() + ';\n                }\n                \n                .' + _constants.CLASSES.DATE_PICKER_DAY + ' .' + _constants.CLASSES.DATE_PICKER_MARKER + ' {\n                    background-color: ' + fieldColor + ';\n                    border: none;\n                    display: none;\n                }\n                \n                .' + _constants.CLASSES.DATE_PICKER_DAY + ':not(.' + _constants.CLASSES.DATE_PICKER_DAY_SELECTED + ').' + _constants.CLASSES.DATE_PICKER_DAY_HOVERED + ' .' + _constants.CLASSES.DATE_PICKER_MARKER + ' {\n                    background-color: transparent;\n                    border: 1px solid ' + fieldColor + ';\n                    display: block;\n                }\n            ';
    }

    function getColor(propName, appStyleParamsColors, siteColors, overridingColors, defaultColor) {
        var color = null;

        if (propName && appStyleParamsColors[propName]) {
            color = appStyleParamsColors[propName];
        } else if (propName) {
            if (overridingColors[propName]) {
                color = overridingColors[propName];
            } else if (siteColors[propName]) {
                color = siteColors[propName];
            }
        }

        if (!color) {
            if (overridingColors[defaultColor]) {
                color = overridingColors[defaultColor];
            } else if (siteColors[defaultColor]) {
                color = siteColors[defaultColor];
            } else if (appStyleParamsColors[defaultColor]) {
                color = appStyleParamsColors[defaultColor];
            }
        }

        return getColorValue(color);
    }

    function getNumber(propName, appStyleParams, defaultNumber) {
        return propName && appStyleParams.numbers.hasOwnProperty(propName) ? appStyleParams.numbers[propName] : defaultNumber;
    }

    function getFont(propName, appStyleParamsFonts, siteFonts, overridingFonts, defaultFont) {
        var font = null;

        if (propName && appStyleParamsFonts[propName]) {
            font = appStyleParamsFonts[propName];
        } else if (propName) {
            if (overridingFonts[propName]) {
                font = overridingFonts[propName];
            } else if (siteFonts[propName]) {
                font = siteFonts[propName];
            }
        }

        if (!font) {
            if (overridingFonts[defaultFont]) {
                font = overridingFonts[defaultFont];
            } else if (siteFonts[defaultFont]) {
                font = siteFonts[defaultFont];
            } else if (appStyleParamsFonts.fonts[defaultFont]) {
                font = appStyleParamsFonts.fonts[defaultFont];
            }
        }

        return getFontValue(font);
    }
}